
let cleanup = null
let activeTab = null

const menu = document.getElementById('menu')
const closeBtn = document.getElementById('close')

// 🔥 génération grille 15 scènes
for (let i = 1; i <= 11; i++) {
  const num = String(i).padStart(2, '0')

  const div = document.createElement('div')
  div.className = 'tab'

  div.innerHTML = `
    <img src="/previews/scene${i}.png"
         onerror="this.style.display='none';this.nextElementSibling.style.display='flex'">
    <div class="thumb-placeholder" style="display:none">◈</div>
    <div class="tab-label">${num} — Scene ${i}</div>
  `

  div.onclick = () => loadScene(`scene${i}`, div)

  menu.appendChild(div)
}

async function loadScene(name, tabEl) {
  if (activeTab) activeTab.classList.remove('active')
  tabEl.classList.add('active')
  activeTab = tabEl

  if (cleanup) {
    cleanup()
    cleanup = null
  }

  try {
    const module = await import(`./scripts/${name}.js`)
    
    const canvas = document.getElementById('canvas')
    canvas.style.display = 'block'
    document.getElementById('close').style.display = 'block'

    if (module.default) {
      cleanup = module.default(canvas)
    }
  } catch (error) {
    console.error(`Erreur au chargement de ${name}:`, error)
    alert(`Impossible de charger ${name}`)
  }
}

function closeScene() {
  if (cleanup) {
    cleanup()
    cleanup = null
  }

  if (activeTab) {
    activeTab.classList.remove('active')
    activeTab = null
  }

  document.getElementById('canvas').style.display = 'none'
  document.getElementById('close').style.display = 'none'
}

closeBtn.addEventListener('click', closeScene)
